import {
	Directive,
	ElementRef,
	Input,
	OnInit,
	SecurityContext
}                       from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


@Directive( {
	selector: '[appSetAttributeDirective]'
} )
export class SetAttributeDirective implements OnInit {

	private _value: any;

	@Input() attribute: string = null;
	@Input() sanitizeDom: boolean;

	@Input() set value( value: any ) {
		this._value = value;
		this.setAttribute( this.attribute );
	}

	constructor(
		private readonly element: ElementRef,
		private readonly domSanitizer: DomSanitizer
	) {}

	ngOnInit() {
		this.sanitizeDom = this.sanitizeDom ?? true;
		this.setAttribute( this.attribute );
	}

	setAttribute( attribute: string ): void {
		if ( attribute === 'innerHTML' && this.sanitizeDom ) {
			this.element.nativeElement[ attribute ] = this.domSanitizer.sanitize( SecurityContext.HTML, this._value );
		} else {
			this.element.nativeElement[ attribute ] = this._value;
		}
	}
}
